import { useStore } from '@nanostores/react';
import { useMemo } from 'react';
import { useActiveBundle } from '@/context/active-bundle';
import { localCommandsAtom, type LocalCommand } from './local-commands';
import { matchesLocalCommand } from './utils';

/**
 * Returns local commands to show in the command dialog: commands for the active app
 * (from the store), filtered by the search query.
 */
export function useStoredHydraCommands(searchQuery: string): LocalCommand[] {
  const localCommandsMap = useStore(localCommandsAtom);
  const activeApp = useActiveBundle();

  return useMemo(() => {
    const commands: LocalCommand[] = [];
    for (const [, entry] of localCommandsMap) {
      if (activeApp === entry.app) {
        commands.push(...entry.commands);
      }
    }
    return commands.filter(matchesLocalCommand(searchQuery));
  }, [localCommandsMap, activeApp, searchQuery]);
}
